import { Editor, Path, Transforms, Node } from 'slate';
import { isExpanded, getNodes, moveChildren } from '@udecode/slate-plugins';
import { BLOCK_TABLE, BLOCK_TABLE_CELL } from '../types';
import { getEmptyTableCell } from '../utils/get-empty-table-cell';

export const mergeCells = (editor) => {
  const isRange = isExpanded(editor.selection);
  const currentCells = isRange ? Array.from(Editor.nodes(editor, {
    match: n => n.type === BLOCK_TABLE_CELL,
  })) : [Editor.above(editor, {
    match: n => n.type === BLOCK_TABLE_CELL,
  })];

  if (currentCells.length) {
    const colspan = currentCells.reduce((total, [cell]) => {
      total += (cell.colspan || 1);
      return total;
    }, 0);
    const [[mainCell,mainCellPath], ...rest]= currentCells;
    Editor.withoutNormalizing(editor, () => {
      console.log({currentCells})
      const reverseRest = rest.reverse();
      const children = [];
      // for (const [cellNode, cellPath] of rest) {
      //   moveChildren(editor, { at: [cellPath, 0], to: [...mainCellPath, mainCell.children.length] })
      // }
      for (const [cellNode, cellPath] of reverseRest) {
        cellNode.children.map((c) => {
          if (c.type  === 'p') {
            children.push(c.children);
          } else {
            children.push(c);
          }
        })
        
        Transforms.removeNodes(editor, { at: cellPath } )
      }
      const lastChildIndex =  mainCell.children.length - 1;
      const lastChild =  mainCell.children[lastChildIndex]
      Transforms.insertNodes(editor, children.reverse().flat(), {
          at: [...mainCellPath, lastChildIndex, lastChild.children.length]
        })
     
      Transforms.setNodes(
        editor,
        {
          colspan,
        },
        {
          at: mainCellPath,
          mode: 'highest'
        },
      );
    })
  }
}
